// extracted by extract-css-chunks-webpack-plugin
module.exports = {"popup-box":"popup-box_o0USn"};